function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStopIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    viewBox: "0 0 300 299.999988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "stopicon"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.669922%,23.139954%,39.99939%)",
      fillOpacity: 1
    },
    d: "M 150 0 C 67.160156 0 0 67.160156 0 150 C 0 232.839844 67.160156 300 150 300 C 232.839844 300 300 232.839844 300 150 C 300 67.160156 232.839844 0 150 0 Z M 258.332031 150 C 258.332031 171.375 252.058594 191.25 241.375 208.042969 L 91.964844 58.632812 C 108.75 47.941406 128.625 41.667969 150 41.667969 C 209.832031 41.667969 258.332031 90.175781 258.332031 150 Z M 41.667969 150 C 41.667969 128.625 47.941406 108.75 58.632812 91.964844 L 208.042969 241.375 C 191.25 252.058594 171.375 258.332031 150 258.332031 C 90.175781 258.332031 41.667969 209.832031 41.667969 150 Z M 41.667969 150 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/StopIcon.96b137a3.svg";
export { ForwardRef as ReactComponent };